<div class="modal-content">
  <div class="modal-header bg-primary-100">
    <h5 class="modal-title">Send Professional Development Request to an LEA</h5>
  </div>
  <div class="modal-body">
    <form #sendLeaRequestForm="ngForm" autocomplete="off">
      <cert-pd-person-search
        [results]="searchResults()"
        [searching]="searching()"
        (search)="onSearch($event)"
        (personSelected)="onSelectPerson($event)"
      />

      @if (selectedPerson) {
        <div class="row mb-2">
          <div class="col-4 form-group">
            <label for="ein" class="form-label">EIN</label>
            <input
              id="ein"
              type="text"
              class="form-control field"
              [(ngModel)]="selectedPerson.ein"
              name="ein"
              disabled
            />
          </div>
          <div class="col-4 form-group">
            <label for="lastName" class="form-label">Last Name</label>
            <input
              id="lastName"
              type="text"
              class="form-control field"
              [(ngModel)]="selectedPerson.lastName"
              name="lastName"
              disabled
            />
          </div>
          <div class="col-4 form-group">
            <label for="firstName" class="form-label">First Name</label>
            <input
              id="firstName"
              type="text"
              class="form-control field"
              [(ngModel)]="selectedPerson.firstName"
              name="firstName"
              disabled
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12 col-md-6">
            <label for="targetLeaCodeId" class="form-label">Target LEA</label>
            <ng-select
              #targetLeaCodeId="ngModel"
              id="targetLeaCodeId"
              name="targetLeaCodeId"
              [closeOnSelect]="true"
              [multiple]="false"
              [(ngModel)]="selectedTargetLeaCodeId"
              placeholder="Select an LEA to send this request to..."
            >
              @for (lea of leaCodes; track lea.leaCodeId) {
                <ng-option [value]="lea.leaCodeId">{{ lea.displayName }}</ng-option>
              }
            </ng-select>
            <div validationErrors [for]="targetLeaCodeId.control" [errorEmitter]="errorEmitter"></div>
          </div>
        </div>

        <div class="mb-2">
          <label for="requestDetails" class="form-label">Request Details</label>
          <textarea
            #requestDetailsModel="ngModel"
            id="requestDetails"
            name="requestDetails"
            rows="4"
            class="form-control"
            [(ngModel)]="requestDetails"
            placeholder="Enter request details..."
            maxlength="1000"
          ></textarea>
          <small class="fst-italic">{{ requestDetails.length }}/1000</small>
          <div validationErrors [for]="requestDetailsModel.control" [errorEmitter]="errorEmitter"></div>
        </div>
        <div class="mb-2">
          @if (requestDetails.length > 0) {
            <label class="fst-italic" for="requestDetailsPreview">Request Details Markdown Preview</label>
            <div id="requestDetailsPreview" markdown [data]="requestDetails"></div>
          }
        </div>
      } @else {
        <div>
          <p class="fst-italic">No person selected. Please search for and select a person to send a request.</p>
        </div>
      }
      <div formLevelValidationErrors [for]="sendLeaRequestForm" [errorEmitter]="errorEmitter" class="mb-3"></div>
    </form>
  </div>
  <div class="modal-footer d-flex">
    <button type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="submitting()">Cancel</button>
    @if (selectedPerson) {
      <button type="button" class="btn btn-primary" (click)="confirm()" [disabled]="submitting()">Send Request</button>
    }
  </div>
</div>
